import React from "react";

const AssetNetworkTest: React.FC = () => {
  return <div>Network test!</div>;
};

export default AssetNetworkTest;
